<ng-container *ngIf="compData">
  <div *ngIf="compData.contractSummaryResponse && compData.contractSummaryResponse.responseCode=='200' && compData.contractSummaryResponse.contractSummary">
    <div class="container" *ngFor="let contract of compData.contractSummaryResponse.contractSummary; let i = index">
      <ng-container *ngIf="contract.status && contract.status.toLowerCase() != 'suppress'">
        <div class="product-box col-xs-12 pt-4 pb-4" id="{{contract.contractID | setAnchor:contract.lineOfBusiness}}"
          [attr.data-ct-analytics]="contract.contractID" [attr.data-qa]="'ucd-product-box'"
          *ngIf="!(contract.contractStatus && contract.contractStatus.toLowerCase() =='pending')"
          [attr.data-analytics]="'0|'+(i+1)">
          <h3 class="h4 product-title mt-0" *ngIf="contract.lineOfBusiness" [attr.data-qa]="'ucd-product-title'">
            <span class="product-title-lob product-subtitle">{{contract.lineOfBusiness}}</span>
          </h3>
          <div class="row contract-header">
            <div class="col-sm-12 col-md-7 product-title">

              <ng-container *ngIf="contract.productTypeHeader;else noProductTypeHeader">
                <h4 class="h2">
                  <a [attr.href]="contract.contractDetailLink? (contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)):null"
                    class="product-title-type" [attr.data-qa]="'ucd-product-contractDetailLink'">
                    <span class="text-capitalize product-name" *ngIf="contract.productTypeHeader.indexOf('Type')>-1">
                      <span [attr.data-qa]="'ucd-product-type'" [innerHTML]="contract.productType"></span>
                      <span [attr.data-qa]="'ucd-product-type_mutual_funds'"
                        *ngIf="contract.lineOfBusiness && contract.lineOfBusiness.toLowerCase() == 'mutual funds'">Mutual Funds</span>
                      <span *ngIf="contract.productTypeHeader.indexOf('ID')>-1">
                        <span class="h4 contractid" *ngIf="(contract.lineOfBusiness && contract.lineOfBusiness.toLowerCase() != 'retirement') && !contract.productTitle">
                          <span class="product-subtitle" *ngIf="contract.contractID"
                            [attr.data-qa]="'ucd-contractid'"><span class="sr-only">Account Number:
                            </span>#{{contract.contractID | mask:(contract.maskContractID || (contract.productTypeHeader && contract.productTypeHeader.indexOf('Masked')>-1))}}</span>
                        </span>
                      </span>
                    </span>
                    <span *ngIf="contract.productTypeHeader.indexOf('Type')<0">
                      <span class="text-capitalize">{{contract.productTitle}}</span>
                      <span class="contractid" *ngIf="contract.contractID"><span class="sr-only">Account Number: </span>#{{contract.contractID | mask: (contract.productTypeHeader.indexOf('Masked')>-1).toString()}}</span>
                    </span>
                  </a>
                </h4>
                <span class="product-title-lob" *ngIf="contract.productTitle" [attr.data-qa]="'ucd-productTitleCode'">
                  <span class="product-subtitle"
                    *ngIf="!contract.productTitleCode || 
              (contract.productTitleCode && contract.productTitleCode.toLowerCase() !== 'lbnone')">{{contract.productTitle}}</span>
                  <a class="product-subtitle"
                    [href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)"
                    *ngIf="contract.lineOfBusiness.toLowerCase() != 'retirement'"
                    [attr.data-qa]="'ucd-productTitleCode_product-title'">
                    <span class="sr-only">Account Number: </span> #{{contract.contractID | mask:(contract.maskContractID
                    ||
                    contract.productTypeHeader.indexOf('Masked')>-1 || contract.status.toLowerCase()=='missing')}}
                  </a>
                </span>
              </ng-container>
              <ng-template #noProductTypeHeader>
                <h4 class="h2">
                  <a [attr.href]="contract.contractDetailLink? (contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)):null"
                    class="product-title-type" [attr.data-qa]="'ucd-product-contractDetailLink'">
                    <span class="text-capitalize product-name" [attr.data-qa]="'ucd-product-type'"
                      [innerHTML]="contract.productType" *ngIf="contract.productType"></span>
                    <span class="text-capitalize product-name" [attr.data-qa]="'ucd-product-type_mutual_funds'"
                      *ngIf="contract.lineOfBusiness && contract.lineOfBusiness.toLowerCase() == 'mutual funds'">
                      Mutual Funds</span>
                    <span class="h4 contractid" *ngIf="!contract.productTitle"
                      [hidden]="(contract.lineOfBusiness && contract.lineOfBusiness.toLowerCase() == 'retirement')">
                      <span class="product-subtitle" *ngIf="contract.contractID" [attr.data-qa]="'ucd-contractid'"><span
                          class="sr-only">Account Number: </span>#{{contract.contractID
                        | mask:(contract.maskContractID || contract.status.toLowerCase() =='missing')}}</span>
                    </span>
                  </a>
                </h4>
                <div class="h4 product-title-lob-inner" *ngIf="contract.productTitle"
                  [attr.data-qa]="'ucd-productTitleCode'">
                  <span class="product-subtitle"
                    *ngIf="!contract.productTitleCode || 
              (contract.productTitleCode && contract.productTitleCode.toLowerCase() !== 'lbnone')">{{contract.productTitle}}</span>
                  <a class="product-subtitle"
                    [attr.href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: contract.contractID"
                    *ngIf="contract.lineOfBusiness.toLowerCase() != 'retirement'"
                    [attr.data-qa]="'ucd-productTitleCode_product-title'">
                    <span class="sr-only">Account Number: </span>
                    #{{contract.contractID | mask:contract.maskContractID}}
                  </a>
                </div>
              </ng-template>
            </div>
            <div class="col-md-5 text-right-md text-right-lg sm-btm-20">
              <a *ngIf="contract.contractDetailLink" class="btn btn-primary quick-actions" [attr.data-qa]="'ucd-viewDetails'"
                [href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)">View
                Details
                <span class="sr-only"> on {{contract.productType}}</span></a>
              <div class="btn-group quick-actions" *ngIf="contract.accountActions && contract.accountActions.length > 0">
                <button type="button" [attr.data-qa]="'ucd-quick-actions'" class="btn btn-default dropdown-toggle"
                  data-toggle="dropdown" aria-expanded="false" aria-haspopup="true">Quick Actions
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-right" [attr.data-qa]="'ucd-quick-actions-ul'" role="menu">
                  <li *ngFor="let action of contract.accountActions; let idx = index"
                    [attr.data-qa]="'ucd-quick-actions-li_'+idx"
                    [hidden]="action.actionTitle == 'View My Coverage' && contract.lineOfBusiness == 'Life Insurance'">
                    <a [attr.href]="action.actionTarget|contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)"
                      (click)="_genericService.openSecondary($event, action.linkTarget, action.actionTarget, action.popupWidth, action.popupHeight)"
                      role="menuitem">{{action.actionTitle}}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row"
            *ngIf="contract.userMsg && (contract.status && (contract.status.toLowerCase() == 'warning' || contract.status.toLowerCase() == 'blocked'))">
            <!-- <div class="col-sm-12 hidden-xs">
          <hr [hidden]="!contract.primaryContractValue.value" [attr.data-qa]="'ucd-primaryContractValue'"> 
        </div> -->
            <div class="col-sm-12 hidden-xs" *ngIf="contract.userMsg">
              <div class="alert alert-info alert-inline" role="alert" [attr.data-qa]="'ucd-userMsg'">
                <span class="sr-only">warning</span>
                <p class="msg-body">{{contract.userMsg}}</p>
              </div>
            </div>
          </div>
          <div class="row"
            *ngIf="contract.status && (contract.status.toLowerCase() == 'success' || contract.status.toLowerCase() == 'warning')">
            <!--  <div class="col-sm-12 hidden-xs">
          <hr class="margin-top-10" [hidden]="(!(contract.primaryContractValue.value) 
                    && contract.primaryContractValue.valueType.toLowerCase() != 'hide') 
                    || (contract.primaryContractValue.valueType.toLowerCase() == 'hide' 
                    && !(contract.secondaryContractValues || contract.alertMessages))" />
        </div> -->
            <div class="col-sm-12" *ngIf="contract.alertMessages">
              <div *ngFor="let alert of contract.alertMessages; let idx = index">
                <div *ngIf="alert.messageType && alert.messageType.toLowerCase() == 'alert'">
                  <ng-container *ngIf="alert.messageSourceEndPoint; else serviceMessageData">
                    <acct-msg *ngIf="alert.messageSourceEndPoint=='AcctMsg'" [metadata]="{'msgCd': alert.definitionID}"></acct-msg>
                  </ng-container>

                  <ng-template #serviceMessageData>
                    <div class="alert alert-{{alert.alertType?alert.alertType:'warning'}} alert-inline"
                      [attr.data-qa]="'ucd-alertMessages_'+idx" role="alert"
                      *ngIf="alert.messageType && alert.messageType.toLowerCase() == 'alert'">
                      <span class="sr-only">{{alert.alertType?alert.alertType:'warning'}}</span>
                      <h2 class="h3 alert-title">{{alert.messageTitle? alert.messageTitle:'Alert:'}}</h2>
                      <p class="msg-body">{{alert.messageBody }}</p>
                      <p *ngIf="alert.messageLink">
                        <a [href]="alert.messageLink">{{alert.messageLinkLabel?alert.messageLinkLabel:'View Details'}}
                          <span class="sr-only"> on {{alert.messageTitle? alert.messageTitle:'Alert'}}</span>
                        </a>
                      </p>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="col-xs-12"
              *ngIf="!contract.primaryContractValue || (contract.primaryContractValue && contract.primaryContractValue.value === undefined && (contract.primaryContractValue.valueType===undefined || contract.primaryContractValue.valueType.toLowerCase() != 'hide')) && !(contract.userMsg)">
              <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'ucd-alert_userMsg'">
                <span class="sr-only">Warning</span>
                <h2 class="h3 alert-title">Alert:</h2>
                <div class="msg-body">
                  <error-msg [lob]="compData.businessUnit" msgcode="tech"></error-msg>
                </div>
              </div>
            </div>
            <div class="col-xs-12 product-top">
              <div class="row">
                <div [ngClass]="redesign?'col-sm-6':'col-sm-5'">
                  <div class="pt-2" *ngIf="contract.primaryContractValue?.valueType?.toLowerCase() != 'hide'">
                    <span class="product-primary" [attr.data-qa]="'ucd-product-primary-title'">
                      <span class="small" *ngIf="contract.primaryContractValue">
                        <a class="product-subtitle product-account"
                          [attr.href]="contract.contractDetailLink | contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)">{{contract.primaryContractValue.title}}</a>
                      </span>
                    </span>
                    <pru-tooltip
                      *ngIf="contract.primaryContractValue && contract.primaryContractValue.titleToolTip && contract.primaryContractValue.title"
                      [definitionID]="contract.primaryContractValue.titleToolTip.definitionID"
                      [definitionLocation]="contract.primaryContractValue.titleToolTip.definitionLocation"
                      [clickTitle]="contract.primaryContractValue.title | toolTipFormat"
                      [screenReaderText]="contract.primaryContractValue.title"
                      [analyticData]="contract.primaryContractValue.title" [attr.data-qa]="'ucd-tooltipLink'">
                    </pru-tooltip>
                    <p class="product-primary pt-3 mb-0" [ngClass]="{'sm-no-border': contract.noSecondary}"
                      [attr.data-qa]="'ucd-primaryContractValue'">
                      <span class="primary-value"
                        *ngIf="contract.primaryContractValue && contract.primaryContractValue.value && contract.primaryContractValue.valueType">
                        <span
                          *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'amount'">{{contract.primaryContractValue.value
                          | currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                        <span
                          *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'restrictedamount'">${{contract.primaryContractValue.value}}</span>
                        <span
                          *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'amount' || contract.primaryContractValue.valueType.toLowerCase() == 'restrictedamount'">
                          <span *ngIf="contract.primaryContractValue.descPos; else nodescpos">
                            <span class="smaller"
                              *ngIf="contract.primaryContractValue.descPos=='inline'">{{contract.primaryContractValue.valueDesc}}</span>
                          </span>
                          <ng-template #nodescpos>
                            <span class="smaller"
                              *ngIf="contract.primaryContractValue && contract.primaryContractValue.title && contract.primaryContractValue.title.toLowerCase()=='guaranteed lifetime income'">/yr</span>
                          </ng-template>
                        </span>
                        <span *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'date' 
                            || contract.primaryContractValue.valueType.toLowerCase() == 'text' 
                            || contract.primaryContractValue.valueType.toLowerCase() == 'notavailable'"
                          [ngClass]="{'alert-warning alert-text': contract.primaryContractValue.value && contract.primaryContractValue.valueType.toLowerCase() == 'notavailable'}">
                          {{contract.primaryContractValue.value}}
                        </span>
                      </span>
                    </p>
                    <p class="product-primary mb-0" [ngClass]="{'product-border': contract.secondaryContractValues}"
                      [attr.data-qa]="'ucd-asOfDate'">
                      <span class="small product-subtitle contract-date" *ngIf="contract.asOfDate">As of
                        {{contract.asOfDate}}</span>
                    </p>
                  </div>
                </div>
                <div class="product-secondary" [ngClass]="redesign?'col-sm-6':'col-sm-7'"
                  *ngIf="contract.secondaryContractValues">
                  <ul class="list-unstyled secondarygroup" [attr.data-qa]="'ucd-secondary_ul'"
                    *ngFor="let secondarygroup of contract.secondaryContractValues; let idx = index">
                    <li *ngFor="let secondary of secondarygroup.group|Notlifebenefits:contract.lineOfBusiness"
                      [attr.data-qa]="'ucd-secondary_li_'+idx">
                      <secondary-values *ngIf="secondary" [secondaryElement]="secondary"
                        [productTypeCode]="contract.productTypeCode"></secondary-values>
                      <!-- <div class="row">
                    <div class="col-xs-6 col-sm-12 col-md-6">

                      <p class="h4 secondary-title product-subtitle">{{secondary.title}}
                        <pru-tooltip *ngIf="secondary && secondary.titleToolTip && secondary.title" [definitionID]="secondary.titleToolTip.definitionID | toolTipType: contract.productTypeCode ? contract.productTypeCode : ''"
                          [definitionLocation]="secondary.titleToolTip.definitionLocation" [clickTitle]="secondary.title | toolTipFormat"
                          [analyticData]="secondary.title" [screenReaderText]="secondary.title">
                        </pru-tooltip>
                      </p>
                    </div>
                    <div class="col-xs-6 col-sm-12 col-md-6">

                      <p class="h4 secondary-val">
                        <span *ngIf="secondary.valueType && secondary.valueType.toLowerCase() == 'amount'" [innerHtml]="secondary.value | currency:'USD':'symbol-narrow':'1.2-2'">
                        </span>
                        <span *ngIf="secondary.valueType && secondary.valueType.toLowerCase() == 'restrictedamount'"
                          [innerHtml]="secondary.value | currency:'USD':'symbol-narrow':'1.2-2'">
                        </span>
                        <span *ngIf="secondary.valueType && secondary.valueType.toLowerCase() == 'notavailable'">
                          <span class="alert-warning alert-text">Data N/A</span>
                          <span class="sr-only">Data N/A</span>
                        </span>
                        <span class="product-subtitle" *ngIf="secondary.valueType && (secondary.valueType.toLowerCase() != 'restrictedamount'
                                && secondary.valueType.toLowerCase() != 'amount' && secondary.valueType.toLowerCase() != 'notavailable')">
                          {{secondary.value}}
                        </span>
                        <pru-tooltip *ngIf="secondary && secondary.valueToolTip && secondary.value" [definitionID]="secondary.valueToolTip.definitionID | toolTipType: contract.productTypeCode ? contract.productTypeCode : ''"
                          [definitionLocation]="secondary.valueToolTip.definitionLocation" [clickTitle]="secondary.value | toolTipFormat"
                          [analyticData]="secondary.title" [screenReaderText]="secondary.value">
                        </pru-tooltip>
                      </p>
                    </div>
                  </div> -->
                    </li>
                    <li [attr.data-qa]="'ucd-secondary_li_notLife'"
                      [hidden]="contract.lineOfBusiness && contract.lineOfBusiness.toLowerCase() !== 'life insurance'"
                      *ngIf="(secondarygroup.group|lifebenefits:contract.lineOfBusiness).length>0">
                      <div class="row">
                        <div class="col-xs-12">
                          <div class="insetbox">
                            <div class="row">
                              <div class="col-md-6">

                                <p class="h4 secondary-title product-subtitle">
                                  <span>Additional Benefits</span>
                                  <pru-tooltip [definitionID]="'AdditionalBenefits'"
                                    [definitionLocation]="'CO_UCD_ILILib/SA-UCD-ToolTip'"
                                    [clickTitle]="'AdditionalBenefits'" [analyticData]="'Additional Benefits'"
                                    [screenReaderText]="'Additional Benefits'">
                                  </pru-tooltip>
                                  <span *ngIf="contract.accountActions && contract.accountActions.length > 0">
                                    <span *ngFor="let coverage of contract.accountActions">
                                      <span
                                        *ngIf="coverage.actionTitle && coverage.actionTitle.toLowerCase() === 'view my coverage'">
                                        <br>
                                        <a class="small view-coverage-link product-subtitle"
                                          [href]="coverage.actionTarget">View
                                          My Coverage</a>
                                      </span>
                                    </span>
                                  </span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <ul class="list-unstyled" [attr.data-qa]="'ucd-benefit_ul'">

                                  <li
                                    *ngFor="let benefit of secondarygroup.group|lifebenefits:contract.lineOfBusiness; let idx = index;"
                                    [attr.data-qa]="'ucd-benefit_li_'+idx">
                                    <p class="product-subtitle text-right">{{benefit.value}}
                                      <pru-tooltip *ngIf="benefit.valueToolTip && benefit.value"
                                        [attr.data-qa]="'ucd-benefit_li_toolTip'+idx"
                                        [definitionID]="benefit.valueToolTip.definitionID | toolTipType: contract.productTypeCode ? contract.productTypeCode : ''"
                                        [definitionLocation]="benefit.valueToolTip.definitionLocation"
                                        [clickTitle]="benefit.value | toolTipFormat" [analyticData]="benefit.value"
                                        [screenReaderText]="benefit.value">
                                      </pru-tooltip>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="contract.status && contract.status.toLowerCase() == 'error'">
            <div class="col-sm-12 hidden-xs">
              <hr>
            </div>
            <div class="col-sm-12" *ngIf="contract.userMsg">
              <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'ucd-contract_dataErr'">
                <span class="sr-only">{{contract.userMsg || 'Data Error'}}</span>
                <p>{{contract.userMsg || 'Data Error'}}</p>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="contract.status && contract.status.toLowerCase() == 'missing'">
            <div class="col-sm-12 hidden-xs">
              <hr>
            </div>
            <div class="col-sm-12">
              <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'ucd-contract_missing'">
                <span class="sr-only">warning</span>
                <error-msg [lob]="compData.businessUnit" msgcode="missing"></error-msg>
              </div>
            </div>
          </div>
          <div class="row" *ngFor="let alertMessage of contract.alertMessages; let idx = index">
            <ng-container *ngIf="alertMessage.messageType == 'AdditionalBenefit'">
              <div class="col-md-7 pull-right">
                <a [href]="alertMessage.messageLink| contractDetails: contract.lineOfBusiness: (contract.contractID || contract.contractId)"
                  [attr.data-qa]="'ucd-AdditionalBenefit_alerts_'+idx" class="AB_alerts">
                  <pru-wcmdata
                    serviceURL="/wps/wcm/myconnect/{{alertMessage.definitionLocation}}?source=library&srv=cmpnt&cmpntname=UCD_Design/MENU-Help&sitearea={{alertMessage.definitionLocation}}&codes={{alertMessage.definitionID}}&CACHE=SITE&EXPIRES=REL+3600s">
                  </pru-wcmdata>
                  <span *ngIf="alertMessage.messageLink" class="fa fa-angle-double-right"></span>
                </a>
              </div>
            </ng-container>
            <ng-container *ngIf="alertMessage.messageType == 'SpeedBump'">
              <div class="col-md-7 pull-right">
                <speed-bump definitionLocation='{{alertMessage.definitionLocation}}'
                  definitionID='{{alertMessage.definitionID}}'></speed-bump>
              </div>
            </ng-container>
            <div class=" col-sm-12 text-right" *ngIf="alertMessage.messageType == 'VirtualInbox'">
              <a class="auth-link" [href]="alertMessage.messageLink" [attr.data-qa]="'ucd-messageLink'"
                (click)="_genericService.openSecondary($event, alertMessage.messageTarget, alertMessage.messageLink, alertMessage.popupWidth, alertMessage.popupHeight) ">
                <span class="fa fa-envelope "></span>
                <span
                  *ngIf="(alertMessage.newMessageIndicator && alertMessage.newMessageIndicator.toLowerCase()) !='true' ">
                  Message Center</span>
                <span
                  *ngIf="(alertMessage.newMessageIndicator && alertMessage.newMessageIndicator.toLowerCase())=='true' ">
                  New Message</span>
                <span *ngIf="(alertMessage.messageTarget && alertMessage.messageTarget.toLowerCase()) !='self'"
                  class="sr-only"> opens in new window</span>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- contractsummary v2 CSR non-privileged user -->
    <ng-container *ngIf="!compData.contractSummaryResponse.contractSummary">
      <div class="container" *ngIf="_genericService.usr_csr">
        <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
          <div class="row contract-header">
            <div class="col-sm-6 col-md-8 product-title">
              <h3 class="h4 mt-0" [attr.data-qa]="compData.businessUnit">
                <span class="product-title-lob">{{compData.businessUnit}}</span>
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-danger alert-inline" role="alert"
                [attr.data-qa]="compData.businessUnit +'_warning_container'">
                <span class="sr-only">warning</span>
                <error-msg msgcode="csr"></error-msg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="compData.responseCode != 200; else successNoData">
    <div class="container" [attr.data-qa]="'ucd-error-container'">
      <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
        <h3 class="h4 product-title mt-0" [attr.data-qa]="'ucd-error-buName'">
          <span class="product-title-lob">{{compData.businessUnit}}</span>
        </h3>
        <div class="row contract-header">
          <div class="col-sm-6 col-md-8"></div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'ucd-error-alertbox'">
              <span class="sr-only">warning</span>
              <ng-container *ngIf="_genericService.usr_csr; else client">
                <div class="csr-err-msg" [attr.data-qa]="'ucd-csr-error-text'">
                  <error-msg [lob]="compData.businessUnit" msgcode="missing" *ngIf="compData.responseCode != 412">
                  </error-msg>
                  <error-msg msgcode="csr" *ngIf="compData.responseCode == 412"></error-msg>
                </div>
              </ng-container>
              <ng-template #client>
                <div [attr.data-qa]="'ucd-error-p-text'" class="client-err-msg">
                  <error-msg [lob]="compData.businessUnit" msgcode="missing"></error-msg>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #successNoData>
    <div
      *ngIf="!compData.contractSummaryResponse || compData.contractSummaryResponse.responseCode!='200' || !compData.contractSummaryResponse.contractSummary">
      <div class="container" [attr.data-qa]="'ucd-error-container'">
        <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
          <h3 class="h4 product-title mt-0" [attr.data-qa]="'ucd-error-buName'">
            <span class="product-title-lob">{{compData.businessUnit}}</span>
          </h3>
          <div class="row contract-header">
            <div class="col-sm-6 col-md-8"></div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'ucd-error-alertbox'">
                <span class="sr-only">warning</span>
                <ng-container *ngIf="_genericService.usr_csr; else client">
                  <div class="csr-err-msg" [attr.data-qa]="'ucd-csr-error-text'">
                    <ng-container
                      *ngIf="!compData.portfolioResponse || (compData.portfolioResponse && compData.portfolioResponse.responseCode === '200' && compData.portfolioResponse.portfolio && compData.portfolioResponse.portfolio.contracts && compData.portfolioResponse.portfolio.contracts.length === 0); else techDifficulty">
                      <error-msg msgcode="csr"></error-msg>
                    </ng-container>
                    <ng-template #techDifficulty>
                      <error-msg [lob]="compData.businessUnit" msgcode="missing"></error-msg>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-template #client>
                  <div [attr.data-qa]="'ucd-error-p-text'" class="client-err-msg">
                    <error-msg [lob]="compData.businessUnit" msgcode="missing"></error-msg>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</ng-container>